export default "__VITE_ASSET__808296f6__"